import { apiFetch } from '@/lib/auth';
import { useUIStore } from '@/state/store';
import { saveCallSession, clearCallSession } from '@/lib/callSession';

/**
 * Welle 9: Zentrale Annahme/Ablehnung eines eingehenden Calls — genutzt vom
 * Incoming-Screen UND von den OS-Notification-Actions (Service Worker).
 */
export async function acceptIncoming(callId: string): Promise<boolean> {
  try {
    const r = await apiFetch(`/api/calls/${callId}/accept`, { method: 'POST' });
    if (!r.ok) {
      console.warn('[callActions] accept fehlgeschlagen', r.status);
      return false;
    }
    const data = await r.json();
    (useUIStore.getState() as any).rtcToken = data.rtcToken;
    (useUIStore.getState() as any).activeCallId = data.callId;
    (window as any).__rtcToken = data.rtcToken;
    (window as any).__activeCallId = data.callId;
    saveCallSession({ callId: data.callId, rtcToken: data.rtcToken, incoming: (window as any).__incomingCall ?? null });
    useUIStore.getState().setView('incall');
    return true;
  } catch (e) {
    console.warn('[callActions] accept exception', e);
    return false;
  }
}

export async function declineIncoming(callId: string): Promise<void> {
  try {
    await apiFetch(`/api/calls/${callId}/decline`, { method: 'POST' });
  } catch (e) {
    console.warn('[callActions] decline exception', e);
  }
  (window as any).__incomingCall = null;
  clearCallSession();
  const view = useUIStore.getState().view;
  if (view === 'incoming') useUIStore.getState().setView('dashboard');
}
